import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';
import { ReactComponent as Arrow } from '@pkg/components/Sections/Profile/icons/arrow.svg';

const SORT_ICON_SIZE = 40;

export const Wrapper = styled.div`
    && {
        display: inline-flex;
        background: #ffffff1a;
        border-radius: 30px;
        position: relative;
    }
`;

export const DirectionIndicator = styled(motion.div)`
    && {
        position: absolute;
        width: ${SORT_ICON_SIZE}px;
        height: ${SORT_ICON_SIZE}px;
        background: ${({ theme }) => theme.colors.purple};
        border-radius: 50%;
    }
`;

export const DirectionButton = styled(motion(ButtonIcon))`
    &&& {
        width: ${SORT_ICON_SIZE}px;
        height: ${SORT_ICON_SIZE}px;
    }
`;
type ArrowProps = {
    $pointingUp?: boolean;
};
export const StyledArrow = styled(Arrow)<ArrowProps>`
    && {
        ${({ $pointingUp }) =>
            !$pointingUp &&
            css`
                transform: rotate(180deg);
            `}
    }
`;
